
import About from "../components/Work/About";
import Clients from "../components/Work/Clients";
import WeDid from "../components/Work/WeDid";
import WorkWithUs from "../components/Work/WorkWithUs";


export default function Work() {


  return (
    <main className="w-full overflow-x-hidden" style={{ backgroundColor: "#ffffff" }}>

      <div>
        <WeDid/>
        <Clients/>
        <About/>
        <WorkWithUs/>
      </div>

    </main>
  );
}